<template>
  <div class="header">
    <h1 class="header__heading">{{ $t("set of tools") }}</h1>
  </div>
</template>

<script>
export default {};
</script>

<style scoped>
.header {
  min-height: 174px;
  padding: 40px 0 0 32px;
  background-color: #222c44;
}

.header__heading {
  font-size: 36px;
  font-weight: normal;
  color: #ffffff;
}
</style>
